var UICopy = ( function($) {

    UICopy = function() {
        var that = this;

        // CONST
        that.class = {
            selector: 'js-copy'
        };

        that.data_attributes = {
            copy_content: 'copy-content',
            copy_notifier_text: 'copy-notifier-text',
            copy_notifier_icon: 'copy-notifier-icon',
            copy_notifier_class: 'copy-notifier-class',
            copy_notifier_time: 'copy-notifier-time',
        };

        // INIT
        that.init();
    };

    UICopy.prototype.init = function() {
        var that = this;
        
        $.sa.$document.on('click', '.' + that.class.selector, function (e) {
            e.preventDefault();
            
            var $self = $(this),
                copy_content = $self.data(that.data_attributes.copy_content),
                notifier_text = $self.data(that.data_attributes.copy_notifier_text),
                notifier_class = $self.data(that.data_attributes.copy_notifier_class) || 'success',
                notifier_icon = $self.data(that.data_attributes.copy_notifier_icon) || null,
                notifier_time = $self.data(that.data_attributes.copy_notifier_time) || 3000;

            $.sa.copyToBuffer(copy_content);

            if (notifier_text && notifier_text.length) {
                notifier_text = notifier_text.replace('%s', copy_content)
                $.sa.notifier.show({
                    notifier_class: notifier_class,
                    icon_class: notifier_icon,
                    title: notifier_text,
                    time: notifier_time
                });
            }
        });
    };

    return UICopy;

})($);